// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const AdminDashboard = () => {
//   const [tasks, setTasks] = useState([]);
//   const [message, setMessage] = useState("");
//   const [selectedTask, setSelectedTask] = useState(null);
//   const [newPriority, setNewPriority] = useState("Medium");
//   const [closureFeedback, setClosureFeedback] = useState("");

//   const apiUrl = process.env.REACT_APP_API_URL;
//   const token = localStorage.getItem("jwt");

//   // Fetch all tasks
//   const fetchTasks = async () => {
//     try {
//       const res = await axios.get(`${apiUrl}/tasks`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setTasks(res.data);
//     } catch (err) {
//       setMessage(err.response?.data?.error || "Error fetching tasks");
//     }
//   };

//   useEffect(() => {
//     fetchTasks();
//   }, []);

//   // Change task priority
//   const handleChangePriority = async (taskId) => {
//     try {
//       await axios.put(
//         `${apiUrl}/tasks/${taskId}/priority`,
//         { priority: newPriority },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setMessage("Priority updated successfully!");
//       fetchTasks();
//     } catch (err) {
//       setMessage(err.response?.data?.error || "Error updating priority");
//     }
//   };

//   // Close task with feedback
//   const handleCloseTask = async (taskId) => {
//     if (!closureFeedback) return setMessage("Feedback required to close task");
//     try {
//       await axios.put(
//         `${apiUrl}/tasks/${taskId}/close`,
//         { feedback: closureFeedback },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setMessage("Task closed successfully!");
//       setClosureFeedback("");
//       setSelectedTask(null);
//       fetchTasks();
//     } catch (err) {
//       setMessage(err.response?.data?.error || "Error closing task");
//     }
//   };

//   return (
//     <div style={{ maxWidth: 900, margin: "20px auto" }}>
//     <h2>Admin Dashboard</h2>
//       {message && <p style={{ color: "red" }}>{message}</p>}

//       <table style={{ width: "100%", borderCollapse: "collapse" }}>
//         <thead>
//           <tr>
//             <th style={{ border: "1px solid #ccc", padding: "8px" }}>ID</th>
//             <th style={{ border: "1px solid #ccc", padding: "8px" }}>Title</th>
//             <th style={{ border: "1px solid #ccc", padding: "8px" }}>User</th>
//             <th style={{ border: "1px solid #ccc", padding: "8px" }}>Priority</th>
//             <th style={{ border: "1px solid #ccc", padding: "8px" }}>Status</th>
//             <th style={{ border: "1px solid #ccc", padding: "8px" }}>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {tasks.map((task) => (
//             <tr key={task.id}>
//               <td style={{ border: "1px solid #ccc", padding: "8px" }}>{task.id}</td>
//               <td style={{ border: "1px solid #ccc", padding: "8px" }}>{task.title}</td>
//               <td style={{ border: "1px solid #ccc", padding: "8px" }}>{task.user_email}</td>
//               <td style={{ border: "1px solid #ccc", padding: "8px" }}>{task.priority}</td>
//               <td style={{ border: "1px solid #ccc", padding: "8px" }}>{task.status}</td>
//               <td style={{ border: "1px solid #ccc", padding: "8px" }}>
//                 <div>
//                   <select
//                     value={newPriority}
//                     onChange={(e) => setNewPriority(e.target.value)}
//                   >
//                     <option>High</option>
//                     <option>Medium</option>
//                     <option>Low</option>
//                   </select>
//                   <button
//                     onClick={() => handleChangePriority(task.id)}
//                     style={{ marginLeft: "5px" }}
//                   >
//                     Update Priority
//                   </button>
//                 </div>
//                 <div style={{ marginTop: "5px" }}>
//                   <input
//                     type="text"
//                     placeholder="Feedback"
//                     value={selectedTask === task.id ? closureFeedback : ""}
//                     onChange={(e) => {
//                       setSelectedTask(task.id);
//                       setClosureFeedback(e.target.value);
//                     }}
//                   />
//                   <button onClick={() => handleCloseTask(task.id)} style={{ marginLeft: "5px" }}>
//                     Close Task
//                   </button>
//                 </div>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default AdminDashboard;


import React, { useEffect, useState } from "react";
import axios from "axios";
import EmployeeDashboard from "./EmployeeDashboard";
import * as XLSX from "xlsx";
import Watermark from "../components/Watermark"; // <-- new import
import { toast } from "react-hot-toast";

const TABS = ["Admin", "Create a Task"];
const DASHBOARD_TABS = ["Current", "Archive"];
const SORT_OPTIONS = [
  { label: "Task ID Asc", value: "id_asc" },
  { label: "Task ID Desc", value: "id_desc" },
  { label: "Due Date Asc", value: "due_asc" },
  { label: "Due Date Desc", value: "due_desc" },
];

const AdminDashboard = () => {
  const [tab, setTab] = useState("Admin");
  const [dashboardTab, setDashboardTab] = useState("Current");
  const [tasks, setTasks] = useState([]);
  const [sort, setSort] = useState("id_desc");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [editingTaskId, setEditingTaskId] = useState(null);
  const [editPriority, setEditPriority] = useState("");
  const [editDueDate, setEditDueDate] = useState("");
  const [actionMessage, setActionMessage] = useState("");
  const [selectedTask, setSelectedTask] = useState(null);
  const [closureFeedback, setClosureFeedback] = useState("");
  const [adminList, setAdminList] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [usersMap, setUsersMap] = useState({});
  const [closing, setClosing] = useState(false);

//added comment

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("jwt");

  function addBusinessDays(date, days) {
    let result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      // 0 = Sunday, 6 = Saturday
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        added++;
      }
    }
    return result;
  }

    // Fetch users map (now returns the map)
  const fetchUsersMap = async () => {
    try {
      const res = await axios.get(`${apiUrl}/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const map = {};
      (res.data || []).forEach((u) => {
        map[u.id] = `${u.first_name || ""} ${u.last_name || ""}`.trim();
      });
      setUsersMap(map);
      return map; // return map so caller can use immediately
    } catch (err) {
      return {};
    }
  };

  // Fetch tasks (accept optional usersMap param to avoid stale state)
  const fetchTasks = async (usersMapParam = null) => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiUrl}/tasks`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // sort by created_at descending (newest first). fallback to id desc
      const getTime = (t) => {
        if (t.created_at) return new Date(t.created_at).getTime();
        return t.id ? Number(t.id) : 0;
      };
      const sorted = (res.data || []).slice().sort((a, b) => getTime(b) - getTime(a));

      const mapToUse = usersMapParam || usersMap || {};
      const withNames = sorted.map((t) => ({
        ...t,
        created_by_name: mapToUse[t.created_by] || null,
      }));

      setTasks(withNames);
    } catch (err) {
      // handle error if needed
    } finally {
      setLoading(false);
    }
  };

  // bootstrap: load users map first, then tasks; keep auto-refresh for tasks only
  useEffect(() => {
    let interval;
    (async () => {
      const map = await fetchUsersMap();
      await fetchTasks(map); // pass the fresh map to avoid stale state
      interval = setInterval(() => fetchTasks(), 15 * 60 * 1000);
    })();
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   fetchTasks();
  //   const interval = setInterval(fetchTasks, 15 * 60 * 1000); // 15 min auto-refresh
  //   return () => clearInterval(interval);
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    axios.get(`${apiUrl}/users?role=admin`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => setAdminList(res.data))
    .catch(() => {});
  }, []);

  const handleEditClick = (task) => {
  setEditingTaskId(task.id);
  setEditPriority(task.priority);
  setEditDueDate(task.due_date ? task.due_date.split("T")[0] : "");
  setActionMessage("");
  };

  const handlePriorityChange = (priority) => {
  setEditPriority(priority);
  // Set due date based on priority
  let days = 0;
  if (priority === "High") days = 2;
  else if (priority === "Medium") days = 5;
  else if (priority === "Low") days = 10;
  const newDue = addBusinessDays(new Date(), days).toISOString().split("T")[0];
  setEditDueDate(newDue);
  };

  const handleSaveEdit = async (task) => {
  try {
    await axios.put(
      `${apiUrl}/tasks/${task.id}/admin-update`,
      { priority: editPriority, due_date: editDueDate },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setActionMessage("Priority and due date updated!");
    setEditingTaskId(null);
    fetchTasks();
  } catch (err) {
    setActionMessage(err.response?.data?.error || "Error updating task");
  }
  };

  const handleAssign = async (taskId, adminId) => {
    await axios.put(
      `${apiUrl}/tasks/${taskId}/assign`,
      { assigned_to: adminId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    fetchTasks();
  };

  const handleStatusChange = async (taskId, status) => {
    try {
      await axios.put(
        `${apiUrl}/tasks/${taskId}/status`,
        { status },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchTasks();
    } catch (err) {
      setActionMessage(err.response?.data?.error || "Error updating status");
    }
  };

  // confirm close task (used by modal)
  const handleConfirmCloseTask = async () => {
    if (!selectedTask) return;
    if (!closureFeedback.trim()) {
      toast.error("Feedback required to close task");
      return;
    }
    setClosing(true);
    try {
      // Use the existing update endpoint (PUT /tasks/:id) with status=closed
      const url = `${apiUrl.replace(/\/$/, "")}/tasks/${selectedTask.id}`;
      console.log("Closing task - PUT ->", url);
      await axios.put(
        url,
        { status: "closed", feedback: closureFeedback },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success(`Task #${selectedTask.id} closed`);
      setSelectedTask(null);
      setClosureFeedback("");
      fetchTasks();
    } catch (err) {
      console.error("Close task error:", err);
      const serverMsg = err.response?.data?.error || err.response?.data?.message;
      const msg = serverMsg || err.message || "Error closing task";
      toast.error(msg);
    } finally {
      setClosing(false);
    }
  };

  // Filter and sort tasks
  let filteredTasks = tasks || [];

  if (dashboardTab === "Current") {
    filteredTasks = tasks.filter((t) => t.status !== "closed");
  } else {
      filteredTasks = tasks.filter((t) => t.status === "closed");
  }

  // Search
  const q = (search || "").toString().trim().toLowerCase();
  if (q) {
    filteredTasks = filteredTasks.filter((t) => {
      const idStr = (t.id !== undefined && t.id !== null) ? t.id.toString() : "";
      return (
        idStr.toLowerCase().includes(q) ||
        (t.title || "").toString().toLowerCase().includes(q)
      );
    });
  }

  // Sorting
  if (sort === "id_asc") filteredTasks.sort((a, b) => a.id - b.id);
  if (sort === "id_desc") filteredTasks.sort((a, b) => b.id - a.id);
  if (sort === "due_asc") filteredTasks.sort((a, b) => new Date(a.due_date) - new Date(b.due_date));
  if (sort === "due_desc") filteredTasks.sort((a, b) => new Date(b.due_date) - new Date(a.due_date));

  // Pagination
  const totalPages = Math.ceil(filteredTasks.length / rowsPerPage);
  const paginatedTasks = filteredTasks.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  
  // Export to Excel
  const handleExport = () => {
    const data = filteredTasks.map((t) => ({
      ID: t.id,
      Title: t.title,
      Description: t.description,
      "Created By": t.created_by_name || t.created_by,
      "Assigned Employee": t.assignee_name || "Unassigned",
      "Assigned Email": t.assignee_email || "Unassigned",
      Status: t.status,
      Priority: t.priority,
      "Closure Date": t.closed_at ? new Date(t.closed_at).toLocaleDateString() : "",
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Tasks");
    XLSX.writeFile(wb, "tasks_report.xlsx");
  };

  // Group tasks by month
  function groupByMonth(tasks) {
    return tasks.reduce((acc, task) => {
      const month = task.closed_at
        ? new Date(task.closed_at).toLocaleString("default", { month: "long", year: "numeric" })
        : "Unknown";
      if (!acc[month]) acc[month] = [];
      acc[month].push(task);
      return acc;
    }, {});
  }

  if (tab === "Create a Task") {
    return (
    <>
      <div className="mb-4">
      <button
        className="px-4 py-2 rounded bg-neon-cyan text-black font-semibold"
        onClick={() => setTab("Admin")}
      >
        ← Back to Tasks
      </button>
      </div>
      <EmployeeDashboard />
    </>
    );
  }

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <Watermark /> {/* Watermark Component */}
      {/* Tabs */}
      <div className="flex gap-4 mb-6">
        {TABS.map((t) => (
          <button
            key={t}
            className={`px-4 py-2 rounded-lg font-semibold ${tab === t ? "bg-[#7AA33E] text-white" : "bg-[#7AA33E] text-white"}`}
            onClick={() => setTab(t)}
          >
            {t}
          </button>
        ))}
      </div>

      {/* Dashboard Tabs */}
      <div className="flex gap-4 mb-4">
        {DASHBOARD_TABS.map((t) => (
          <button
            key={t}
            className={`px-3 py-1 rounded-lg ${dashboardTab === t ? "bg-[#7AA33E] text-white" : "bg-[#23283a] text-white"}`}
            onClick={() => setDashboardTab(t)}
          >
            {t}
          </button>
        ))}
      </div>

      {/* Sorting & Search */}
      <div className="flex gap-4 mb-4 items-center">
        <select
          value={sort}
          onChange={(e) => setSort(e.target.value)}
          className="rounded-lg bg-white text-black px-3 py-2"
        >
          {SORT_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
        <input
            type="text"
            placeholder="Search by Task ID or Title"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="rounded-lg bg-white text-black px-3 py-2"
        />
        <button
          onClick={handleExport}
          className="ml-auto px-4 py-2 rounded-lg bg-neon-purple text-white font-semibold"
        >
          Export to Excel
        </button>
      </div>

      <h2 className="text-2xl font-bold text-black mb-4">
        {dashboardTab === "Current" ? "Active Tasks" : "Archived Tasks"}
      </h2>

      {/* Tasks Table */}
      {dashboardTab === "Archive" ? (
        Object.entries(groupByMonth(filteredTasks)).map(([month, monthTasks]) => (
          <div key={month} className="mb-8">
            <h4 className="text-lg font-bold mb-2">{month}</h4>
            <div className="overflow-x-auto rounded-lg shadow">
              <table className="w-full min-w-[900px] text-left">
                <thead>
                  <tr className="bg-[#23283a] text-white">
                    <th className="py-2 px-2">Task ID</th>
                    <th className="py-2 px-2">Title</th>
                    <th className="py-2 px-2">Description</th>
                    <th className="py-2 px-2">Priority</th>
                    <th className="py-2 px-2">Due Date</th>
                    <th className="py-2 px-2">Created By</th>
                    <th className="py-2 px-2">Assigned To</th>
                    <th className="py-2 px-2">Status</th>
                    {/* <th className="py-2 px-2">Quick Actions</th> */}
                  </tr>
                </thead>
                <tbody>
                  {monthTasks.map((task) => (
                    <tr key={task.id} className="border-b-2 border-[#2f4449] hover:bg-muted transition">
                      <td className="py-2 px-2">{task.id}</td>
                      <td className="py-2 px-2">{task.title}</td>
                      <td className="py-2 px-2">{task.description}</td>
                      <td className="py-2 px-2">{task.priority}</td>
                      <td className="py-2 px-2">{task.due_date ? new Date(task.due_date).toLocaleDateString() : "-"}</td>
                      <td className="py-2 px-2">{task.created_by_name}</td>
                      <td className="py-2 px-2">{task.assignee_name || "Unassigned"}</td>
                      <td className="py-2 px-2">{task.status}</td>
                      <td className="py-2 px-2">
  {/* Change Priority/Due Date (one-time) */}
  {/* <button
    className="px-3 py-1 rounded bg-neon-lime text-black text-xs font-semibold mb-2"
    onClick={() => handleEditClick(task)}
    disabled={task.priority_updated}
    title={task.priority_updated ? "Already updated once" : "Change Priority/Due Date"}
  >
    Change Priority/Due Date
  </button>
  {editingTaskId === task.id && (
    <div className="flex flex-col gap-2 my-2">
      <select
        value={editPriority}
        onChange={e => handlePriorityChange(e.target.value)}
        className="rounded bg-[#23283a] text-white px-2 py-1"
      >
        <option>High</option>
        <option>Medium</option>
        <option>Low</option>
      </select>
      <input
        type="date"
        value={editDueDate}
        onChange={e => setEditDueDate(e.target.value)}
        className="rounded bg-[#23283a] text-white px-2 py-1"
        style={{ zIndex: 10 }}
      />
      <div className="flex gap-2">
        <button
          className="px-2 py-1 rounded bg-neon-cyan text-black text-xs font-semibold"
          onClick={() => handleSaveEdit(task)}
        >
          Save
        </button>
        <button
          className="px-2 py-1 rounded bg-red-500 text-white text-xs font-semibold"
          onClick={() => setEditingTaskId(null)}
        >
          Cancel
        </button>
      </div>
      {actionMessage && <div className="text-xs text-red-400">{actionMessage}</div>}
    </div>
  )} */}

  {/* Assignee Dropdown */}
  {/* <div className="mt-2">
    <label className="block text-xs text-black mb-1">Assignee</label>
    <select
      value={task.assigned_to || ""}
      onChange={e => handleAssign(task.id, e.target.value)}
      className="rounded bg-[#23283a] text-white px-2 py-1"
    >
      <option value="">Unassigned</option>
      {adminList.map(admin => (
        <option key={admin.id} value={admin.id}>
          {admin.first_name} {admin.last_name} ({admin.email})
        </option>
      ))}
    </select>
  </div> */}

</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))
      ) : (
        <div className="overflow-x-auto rounded-lg shadow">
          <table className="w-full min-w-[900px] text-left">
            <thead>
              <tr className="bg-[#23283a] text-white">
                <th className="py-2 px-2">Task ID</th>
                <th className="py-2 px-2">Title</th>
                <th className="py-2 px-2">Description</th>
                <th className="py-2 px-2">Priority</th>
                <th className="py-2 px-2">Due Date</th>
                <th className="py-2 px-2">Created By</th>
                <th className="py-2 px-2">Assigned To</th>
                <th className="py-2 px-2">Status</th>
                <th className="py-2 px-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={8} className="text-center py-8">Loading...</td>
                </tr>
              ) : filteredTasks.length === 0 ? (
                <tr>
                  <td colSpan={8} className="text-center py-8 text-muted">No tasks found.</td>
                </tr>
              ) : (
                paginatedTasks.map((task) => (
                  <tr key={task.id} className="border-b-2 border-[#2f4449] hover:bg-muted transition">
                    <td className="py-2 px-2">{task.id}</td>
                    <td className="py-2 px-2">{task.title}</td>
                    <td className="py-2 px-2">{task.description}</td>
                    <td className="py-2 px-2">{task.priority}</td>
                    <td className="py-2 px-2">{task.due_date ? new Date(task.due_date).toLocaleDateString() : "-"}</td>
                    <td className="py-2 px-2">{task.created_by_name}</td>
                    <td className="py-2 px-2">{task.assignee_name || "Unassigned"}</td>
                    <td className="py-2 px-2">{task.status}</td>
                    <td className="py-2 px-2">
  {/* Change Priority/Due Date (one-time) */}
  <button
    className="px-3 py-1 rounded bg-neon-lime text-black text-xs font-semibold mb-2"
    onClick={() => handleEditClick(task)}
    disabled={task.priority_updated}
    title={task.priority_updated ? "Already updated once" : "Change Priority/Due Date"}
  >
    Change Priority/Due Date
  </button>
  {editingTaskId === task.id && (
    <div className="flex flex-col gap-2 my-2">
      <select
        value={editPriority}
        onChange={e => handlePriorityChange(e.target.value)}
        className="rounded bg-[#23283a] text-white px-2 py-1"
      >
        <option>High</option>
        <option>Medium</option>
        <option>Low</option>
      </select>
      <input
        type="date"
        value={editDueDate}
        onChange={e => setEditDueDate(e.target.value)}
        className="rounded bg-[#23283a] text-white px-2 py-1"
        style={{ zIndex: 10 }}
      />
      <div className="flex gap-2">
        <button
          className="px-2 py-1 rounded bg-neon-cyan text-black text-xs font-semibold"
          onClick={() => handleSaveEdit(task)}
        >
          Save
        </button>
        <button
          className="px-2 py-1 rounded bg-red-500 text-white text-xs font-semibold"
          onClick={() => setEditingTaskId(null)}
        >
          Cancel
        </button>
      </div>
      {actionMessage && <div className="text-xs text-red-400">{actionMessage}</div>}
    </div>
  )}

  {/* Assignee Dropdown */}
  <div className="mt-2">
    <label className="block text-xs text-black mb-1">Assignee</label>
    <div className="max-w-[220px]">
    <select
      value={task.assigned_to || ""}
      onChange={e => handleAssign(task.id, e.target.value)}
      className="w-full rounded bg-[#23283a] text-white px-2 py-1"
    >
      <option value="">Unassigned</option>
      {adminList.map(admin => (
        <option key={admin.id} value={admin.id}>
          {admin.first_name} {admin.last_name} ({admin.email})
        </option>
      ))}
    </select>
    </div>
  </div>

  {/* Status Dropdown */}
  <div className="mt-2">
    <label className="block text-xs text-black mb-1">Status</label>
    <select
      value={task.status}
      onChange={e => handleStatusChange(task.id, e.target.value)}
      className="rounded bg-[#23283a] text-white px-2 py-1"
    >
      <option value="open">Open</option>
      <option value="in_progress">In Progress</option>
    </select>
  </div>

  {/* Close Task Button */}
  {task.status !== "closed" && (
    <button
      className="mt-2 px-3 py-1 rounded bg-red-500 text-white text-xs font-semibold"
      onClick={() => {
        setSelectedTask(task);
        setClosureFeedback("");
      }}
    >
      Close Task
    </button>
  )}
</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Pagination */}
      <div className="flex items-center justify-between mt-4">
  <div>
    Rows per page:{" "}
    <select
      value={rowsPerPage}
      onChange={e => {
        setRowsPerPage(Number(e.target.value));
        setPage(1);
      }}
      className="rounded bg-[#23283a] text-white px-2 py-1"
    >
      <option value={5}>5</option>
      <option value={10}>10</option>
      <option value={20}>20</option>
    </select>
  </div>
  <div>
    Page {page} of {totalPages || 1}
    <button
      className="ml-4 px-2 py-1 rounded bg-neon-cyan text-black font-semibold"
      disabled={page === 1}
      onClick={() => setPage(page - 1)}
    >
      Prev
    </button>
    <button
      className="ml-2 px-2 py-1 rounded bg-neon-cyan text-black font-semibold"
      disabled={page === totalPages || totalPages === 0}
      onClick={() => setPage(page + 1)}
    >
      Next
    </button>
  </div>
</div>

      {/* Close Task Modal */}
      {selectedTask && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-[#181c2a] p-8 rounded-xl shadow-lg w-full max-w-md">
            <h3 className="text-lg font-bold mb-4">Close Task #{selectedTask.id}</h3>
            <textarea
              className="w-full rounded bg-[#23283a] text-white p-3 mb-4"
              rows={4}
              placeholder="Enter feedback/comments (required)"
              value={closureFeedback}
              onChange={e => setClosureFeedback(e.target.value)}
            />
            <div className="flex gap-4 justify-end">
              <button
                className="px-4 py-2 rounded bg-gray-500 text-white"
                onClick={() => setSelectedTask(null)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded bg-neon-cyan text-black font-semibold"
                disabled={!closureFeedback.trim() || closing}
                onClick={handleConfirmCloseTask}
              >
                {closing ? "Closing..." : "Close Task"}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};


export default AdminDashboard;
// / export default AdminDashboard;